import { Link } from "react-router-dom";
import SpecialCard from "@/components/feature/SpecialCard";
import { specials } from "@/mocks/specials";

export default function SpecialsSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-screen-xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              影视专题片单
            </h2>
            <p className="mt-2 text-sm text-foreground-600">编辑部精心策划，帮你告别选片困难</p>
          </div>
          <Link
            to="/specials"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex"
          >
            全部专题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {specials.slice(0, 3).map((special) => (
            <SpecialCard key={special.id} special={special} />
          ))}
        </div>

        <div className="mt-6 text-center md:hidden">
          <Link
            to="/specials"
            className="inline-flex items-center gap-1 rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-600"
          >
            查看全部专题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}